import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import authentication from "react-azure-b2c";
import { Provider } from "react-redux";
import { configureStore } from "./store";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/lib/integration/react";
// import configData from "./config.json";
import { BrowserRouter } from "react-router-dom";

// authentication.initialize({
//   // your B2C tenant
//   tenant: configData.tenant,
//   // the policy to use to sign in, can also be a sign up or sign in policy
//   signInPolicy: configData.signInPolicy,
//   // the the B2C application you want to authenticate with (that's just a random GUID - get yours from the portal)
//   clientId: configData.clientId,
//   // where MSAL will store state - localStorage or sessionStorage
//   cacheLocation: configData.cacheLocation,
//   // the scopes you want included in the access token
//   scopes: [
    
//     "https://oncueplus.onmicrosoft.com/08a0c450-b1d9-4876-9a8c-159448f1ace1/READ"
//   ],
//   // optional, the redirect URI - if not specified MSAL will pick up the location from window.href
//   redirectUri: configData.redirectUri,
//   postLogoutRedirectUri:configData.redirectUri,
// });


const store = configureStore();

const persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>     
);

 
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
